<template>
	<app-page>
		<app-heading :title="isNew ? 'New Category' : category.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'string-categories' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="category.name"
					required
					:errors="errors.name"
				/>
				<input-text
					label="Slug"
					v-model="category.slug"
					required
					:errors="errors.slug"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.category = await this.$ravello.request()
					.v(2)
					.to('stringcategories')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			category: {
				name: '',
				slug: '',
			},
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.category
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to('stringcategories')
						.create({
							name: this.category.name,
							slug: this.category.slug,
						})
				} else {
					await this.$ravello.request()
						.v(2)
						.to('stringcategories')
						.to(this.id)
						.update({
							name: this.category.name,
							slug: this.category.slug,
						})
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Category successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'string-categories' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
